import {NgModule, APP_INITIALIZER} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {ErrorMessagesModal, HttpErrorInterceptor} from '../infrastructure/interceptors/http-error-interceptor';
import {AuthInterceptor} from '../infrastructure/interceptors/auth.interceptor';
import {ErrorsHandleModule} from '../infrastructure/errors/errors-handler.module';
import { ConfigsLoaderService } from 'app/services/config-loader.service';
import { FormsModule } from '@angular/forms';
import {PreloadThemingService} from '../theming.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';


export function appInitializerFactory(configsLoaderService: ConfigsLoaderService, themingService: PreloadThemingService) {
  return async () => {
    console.log('Configuring');
    // Ejecutar inicializadores en orden mas conveniente
    await configsLoaderService.loadConfigs();
    // Theming necesita apiUrl de ConfigsLoaderService
    await themingService.loadDefaultTheme();
    console.log('Theming configured');
  };
}


@NgModule({
  imports: [
    ErrorsHandleModule,
    HttpClientModule,
    FormsModule,
    CommonModule,
    TranslateModule
  ],
  declarations: [ErrorMessagesModal],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [ConfigsLoaderService, PreloadThemingService],
      multi: true
    }
  ],
})
export class CoreModule {
  constructor() {
  }
}
